module.exports = __webpack_public_path__ + "static/img/fullscreen-image_our-services_768.da00cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/fullscreen-image_our-services_768.png
// module id = bLkh
// module chunks = 0